import { render, staticRenderFns } from "./install_type.vue?vue&type=template&id=a95ff61e&"
import script from "./install_type.vue?vue&type=script&lang=js&"
export * from "./install_type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports